<template>
  <section
    :class="[`combo-container`, className]"
    :style="{ width: containerWidth, height: containerHeight }"
    v-if="type"
  > 
    <!-- <p>{{ items }}</p> -->

    <div class="dim-container" v-if="isOpen" @click="dimClick()"></div>
    <div>
      <p
        :class="[`selected-value`, { active: isOpen, coupon: hasSearch }]"
        :style="{ lineHeight: lineHeight }"
        @click="comboClick"
        @touchStart="comboClick"
      >
      {{ selectedValue }}
    </p>
      <div v-if="isOpen" class="combo-list-container">
        <div v-if="!hasSearch" class="search-filter-wrapper">
          <input
            type="searchFilter"
            :value="searchText"
            @input="updateSearchText"
            placeholder="search"
          />
        </div>
        <ul class="combo_wrapper">
          <li
            v-for="option in filteredItems"
            :key="option.key"
            @click="selectOption(option)"
            :class="[{ coupon: hasSearch }]"
          >
            {{ option.value }}
          </li>
        </ul>
      </div>
    </div>
  </section>
  <section
    :class="[`combo-container`, className]"
    :style="{ width: containerWidth, height: containerHeight }"
    v-else
  > 
    <!-- <p>{{ items }}</p> -->

    <div class="dim-container" v-if="isOpen" @click="dimClick()"></div>
    <div>
      <p
        :class="[`selected-value`, { active: isOpen, coupon: hasSearch }]"
        :style="{ lineHeight: lineHeight }"
        @click="comboClick"
        @touchStart="comboClick"
      >
      {{ typeof selectedValue === 'string' ? $t(selectedValue) : selectedValue }}
    </p>
      <div v-if="isOpen" class="combo-list-container">
        <div v-if="!hasSearch" class="search-filter-wrapper">
          <input
            type="searchFilter"
            :value="searchText"
            @input="updateSearchText"
            placeholder="search"
          />
        </div>
        <ul class="combo_wrapper">
          <li
            v-for="option in filteredItems"
            :key="option.key"
            @click="selectOption(option)"
            :class="[{ coupon: hasSearch }]"
          >
            {{ $t(option.value) }}
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script setup>
import { onMounted, ref, defineProps, defineEmits, watch, computed } from "vue";
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n({ useScope: 'global' })
// console.log(locale.value);
const emit = defineEmits(["onChange"]);
const props = defineProps({
  items: Array,
  className: String,
  width: String,
  height: String,
  isSelectable: Boolean,
  hasSearch: Boolean,
  placeHolder: String,
  type: String
});

let containerWidth = props.width ? props.width : "100%";
let containerHeight = props.height ? props.height : "100%";
const lineHeight = props.height ? props.height : "";
const type = computed(() => props.type)


watch(()=>props, (newVal, oldVal) => {
  containerWidth = props.width
  const newFiltered = props.items.find((ob) => ob.selected);
  selectedValue.value = newFiltered ? newFiltered.value : [];
});

let selectedValue = ref([]);
const filtered = props.items.find((ob) => ob.selected);
// selectedValue.value = filtered ? filtered.value : [];
const searchText = ref("");
let isOpen = ref(false);
const comboClick = () => {
  if (props.isSelectable) {
    return;
  }
  isOpen.value = true;
};

const filteredItems = computed(() => {
  const filterLowerCase = searchText.value.toLowerCase();
  if (filterLowerCase) {
    return props.items.filter((option) =>
      option.value.toLowerCase().includes(filterLowerCase)
    );
  } else {
    return props.items;
  }
});

const updateSearchText = (event) => {
  searchText.value = event.target.value;
};

const selectOption = (event) => {
  selectedValue.value = event.value;
  props.items.forEach((ob) => (ob.selected = false));

  const selectedItem = props.items.find((ob) => ob.key == event.key);
  selectedItem.selected = true;

  emit("onChange", {
    all: props.items,
    selected: selectedItem,
  });

  isOpen.value = false;
  searchText.value = "";
};
const dimClick = () => {
  isOpen.value = false;
};

onMounted(() => {
  if (!props.placeHolder) {
    selectedValue.value = filtered ? filtered.value : [];
  } else {
    selectedValue.value = props.placeHolder;
  }
  // console.log('selectedValue',selectedValue.value);
  
});
</script>

<style scoped lang="scss">
@import "@/assets/scss/components/ui/comboBox.scss";
</style>
